import React from 'react';
import { StyleSheet } from 'react-native';

import { type AddressType, BodyText, TextSpace } from '@sg/garnish';

import {
  BagChannelHeader,
  BagLocationFromConnector,
  BagLocationHeader,
  BagLocationToConnector,
} from '../../Header';

/**
 * Shortened header for order channel and location.
 */
export const BagChannelAndLocationInfo = (props: BagChannelAndLocationInfoProps) => {
  const {
    orderChannel,
    locationName,
    requestChannelOrLocationChange,
    requestDeliveryPreferencesChange,
  } = props;

  return (
    <BodyText style={styles.headerText} sizeMatch={['16']} numberOfLines={1}>
      {orderChannel === 'outpost' ? null : (
        <BagChannelHeader
          nonFocusable
          accessibilityRole="link"
          orderChannel={orderChannel}
          requestChannelOrLocationChange={requestChannelOrLocationChange}
        />
      )}

      {orderChannel === 'outpost' ? null : <TextSpace />}

      {orderChannel === 'pickup' ? <BagLocationFromConnector /> : null}

      {orderChannel === 'delivery' ? <BagLocationToConnector /> : null}

      {orderChannel === 'outpost' ? null : <TextSpace />}

      <BagLocationHeader
        nonFocusable
        accessibilityRole="link"
        orderChannel={orderChannel}
        locationName={locationName}
        requestDeliveryPreferencesChange={requestDeliveryPreferencesChange}
        requestChannelOrLocationChange={requestChannelOrLocationChange}
      />
    </BodyText>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerText: {
    textAlign: 'center',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type BagChannelAndLocationInfoProps = {
  orderChannel: AddressType;
  locationName: string;
  requestChannelOrLocationChange: () => void;
  requestDeliveryPreferencesChange: () => void;
};
